import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import "./RequestStateInfoList.scss";

const RequestStateInfoList = (props) => {
  const { t, type } = props;

  const requestStates = [
    {
      color: "orange",
      state: t("PENDING"),
    },
    {
      color: "yellow",
      state: t("SOLUTIONS_CONSULTATIONS"),
    },
    {
      color: "light-blue",
      state: t("Pending transport quotation"),
    },
    {
      color: "dark-blue",
      state: t("TRANSPORT_QUOTED"),
    },
    {
      color: "green",
      state: t("TECHINCAL_APPROVED"),
    },
    {
      color: "yellow-border",
      state: t("RE_QUOTE"),
    },
    {
      color: "light-blue-border",
      state: t("PENDING_TRANSPORT_RE_QUOTATION"),
    },
    {
      color: "dark-blue-border",
      state: t("TRANSPORT_RE_QUOTED"),
    },
    {
      color: "grey",
      state: t("CANCELED"),
    },
  ];

  return (
    <>
      {type === 1 && (
        <ul className="request-state-list__info-container">
          <li className="request-state-list__info-box">
            <div className="request-state-list__info-status request-state-list__info-status--green" />
            <span className="request-state-list__info-status-text">
              &gt;24H
            </span>
          </li>
          <li className="request-state-list__info-box">
            <div className="request-state-list__info-status" />
            <span className="request-state-list__info-status-text">
              &lt;24H
            </span>
          </li>
          <li className="request-state-list__info-box">
            <div className="request-state-list__info-status request-state-list__info-status--black" />
            <span className="request-state-list__info-status-text">
              {t("DATE_OUTDATED")}
            </span>
          </li>
        </ul>
      )}
      {type === 2 && (
        <ul className="request-state-list__info-container">
          {requestStates.map((state) => {
            return (
              <li className="request-state-list__info-box" key={state.state}>
                <div
                  className={`request-state-list__info-status request-state-list__info-status--${state.color}`}
                />
                <span className="request-state-list__info-status-text">
                  {state.state}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

RequestStateInfoList.propTypes = {
  type: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(RequestStateInfoList);
